import React from 'react';
import { FeedbackContainer } from './Styled';

interface FeedbackProps {
  label: string;
}

const Feedback = ({ label }: FeedbackProps) => (
  <FeedbackContainer>
    <span>{label}</span>
  </FeedbackContainer>
);

Feedback.defaultProps = {
  label: 'Feedback',
};

export default Feedback;
export { Feedback };
